export default function BodyStyle(props) {
  document.body.style.background = props.background;

  return null;
}
